// import { keyframes } from '@fluentui/merge-styles'; //kan benyttes hvis man skal lage egne keyframe anismasjoner
import { AnimationClassNames } from '@fluentui/react';

export const Animation = {
  errorMessage: AnimationClassNames.slideDownIn20,
};
